import {container, TYPES} from "../../inversifyconfig/container.config.ts";
import {IHttpRequest, IHttpResponse} from "../../interfaces/IHttp.ts";

import {IPaginatedResponse} from "../../interfaces/api/PaginatedResponse.ts";
import {AxiosError} from "axios";

export enum UserGroupSyncStatus {
    Completed = "Completed",
    DiffCreated = "DiffCreated",
    Executing = "Executing",
    Failed = "Failed"
}

export interface IUserGroupSyncHistory {
    "id": number,
    "orgId": number,
    "status": UserGroupSyncStatus,
    "usersProcessed": number,
    "groupsCreated": number,
    "userGroupsAdded": number,
    "userGroupsRemoved": number,
    "groupsExcluded": number,
    "usersExcluded": number,
    "createdAt": string,
    "createdByDisplayName": string,
    "diffCreatedAt": string,
    "executingAt": string,
    "executedAt": string,
    "failureReason": any | null,
    "fileName": string
}

const http = container.get<IHttpRequest>(TYPES.IHttpRequest);

export type IGetUserGroupSyncHistoryResponse = IPaginatedResponse<IUserGroupSyncHistory>;

export async function getUserGroupSyncHistory(skip = 0, take = 20): Promise<IPaginatedResponse<IUserGroupSyncHistory> | AxiosError> {

    try {
        const res = await http.get(`user-group-sync/history`, {params: {skip, take}})
        return res.data
    }

    catch (err: any) {
        return err;
    }
}

export async function createDiff(file: File) {
    try {
        const options = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }

        const formData = new FormData();
        formData.append("file", file);

        const res = await http.post('user-group-sync', formData, options);

        return res.data
    }
    catch (err: any) {
        console.log(err.response);
        return err;
    }
}

export async function completeDiff(syncId: string) {
    try {
        const response: IHttpResponse<any> = await http.post(`user-group-sync/${syncId}/complete`, {});

        return {
            ok: response.status === 200,
        }
    }
    catch(err) {
        return {
            ok: false,
            err: err
        }
    }
}